/* CPP-POPUP-START v1.0 (24-10-2026) | Concept Palermo signup popup | PALERMO10 | Klaviyo list UMBYyf (Welcome) | kopie ML-popup v2 (live) */
(function () {
  'use strict';
  var KEY = 'cp_popup_v1';
  var DAY = 86400000;
  var qs = location.search;
  var FORCE = /[?&](?:cppopup=(?:force|ebf)|ebf=1)/.test(qs);   /* 24-10: ?cppopup=ebf of ?ebf=1 = test, altijd tonen */
  var path = location.pathname.toLowerCase();

  /* never on these paths (with or without locale prefix) */
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|account|pages|policies)(?:\/|$)/.test(path)) return;
  if (path.indexOf('/checkouts') !== -1 || path.indexOf('/apps/') !== -1) return;
  /* not for visitors arriving from our own mails */
  if (!FORCE && /utm_source=klaviyo/i.test(qs)) return;

  function st() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  /* 24-10: aanmelding via de footer (Shopify-nieuwsbrief) telt als aangemeld: pop-up komt dan niet meer */
  if (/customer_posted=true/.test(qs + location.hash)) { var S0 = st(); S0.done = Date.now(); save(S0); }
  document.addEventListener('submit', function (ev) { try { var f = ev.target; if (!f || f.id === 'CPP-form') return;
    var ft = f.querySelector('input[name="form_type"]'); var ce = f.querySelector('input[name="contact[email]"],input[type="email"]');
    if (ft && ft.value === 'customer' && ce && ce.value) { var s9 = st(); s9.done = Date.now(); save(s9); } } catch (e9) {} }, true);
  var S = st(), now = Date.now();
  if (!FORCE) {
    if (S.done && now - S.done < 365 * DAY) return;
    if (S.until && now < S.until) return;
  }

  /* taal = Shopify.locale (markt-URL); zonder prefix = wortelmarkt 'it'. lb (Luxemburg) = de */
  var seg = (path.split('/')[1] || '');
  var segMap = {};
  var lang = null;
  var srcLoc = /^[a-z]{2}-[a-z]{2}$/.test(seg) ? seg : 'it';

  function init() {
    var dictEl = document.getElementById('CPP-i18n');
    var card = document.getElementById('CPP-card');
    var back = document.getElementById('CPP-backdrop');
    if (!dictEl || !card || !back) return;
    var I18N; try { I18N = JSON.parse(dictEl.textContent); } catch (e) { return; }
    if (!lang) {
      var sl = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || '').split('-')[0].toLowerCase();
      if (sl === 'lb') sl = 'de';
      lang = I18N[sl] ? sl : (I18N['it'] ? 'it' : 'en');
    }
    var T = I18N[lang] || I18N.en;
    function put(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
    put('CPP-title', T.title); put('CPP-sub', T.sub);
    put('CPP-fn-l', T.fn); put('CPP-em-l', T.em);
    put('CPP-t-ml', T.min); put('CPP-t-sl', T.sec);
    put('CPP-go', T.cta); put('CPP-no', T.no);
    put('CPP-s-title', T.stitle); put('CPP-s-note', T.snote); put('CPP-s-btn', T.sbtn);
    put('CPP-copy-t', T.copy);
    put('CPP-l1', T.lpre); put('CPP-llink', T.llink); put('CPP-l2', T.lpost);
    var ppHref = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'policies/privacy-policy';
    document.getElementById('CPP-llink').setAttribute('href', ppHref);
    document.getElementById('CPP-x').setAttribute('aria-label', T.close);

    if (window.CPP_EBF) { try { window.CPP_EBF(T, lang, card); } catch (eE) {} }   /* 24-10: Early Black Friday-laag (snippet cp-popup-ebf) */
    /* countdown 03:00, stops at 0:00, form stays usable */
    var left = 180, tick = null;
    function renderT() {
      var m = Math.floor(left / 60), s = left % 60;
      put('CPP-t-m', (m < 10 ? '0' : '') + m);
      put('CPP-t-s', (s < 10 ? '0' : '') + s);
    }
    function startTimer() {
      renderT();
      tick = setInterval(function () {
        left -= 1;
        if (left <= 0) { left = 0; clearInterval(tick); }
        renderT();
      }, 1000);
    }

    var shown = false, prevFocus = null, prevOverflow = '';
    function open() {
      if (shown) return; shown = true;
      prevFocus = document.activeElement;
      back.hidden = false; card.hidden = false;
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        back.className = 'cpp-on'; card.classList.add('cpp-on');
      }); });
      startTimer();
      /* lightweight shown counter (local only; Klaviyo client/events is CORS-blocked, see report) */
      var s = st(); s.shown = (s.shown || 0) + 1; s.lastShown = Date.now(); save(s);
      document.addEventListener('keydown', onKey, true);
    }
    function close(dismiss) {
      back.className = ''; card.classList.remove('cpp-on');
      document.documentElement.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey, true);
      if (tick) clearInterval(tick);
      setTimeout(function () { back.hidden = true; card.hidden = true; }, 330);
      if (prevFocus && prevFocus.focus) { try { prevFocus.focus(); } catch (e) {} }
      if (dismiss) {
        var s = st(); s.n = (s.n || 0) + 1;
        s.until = Date.now() + (s.n >= 2 ? 30 : 7) * DAY;
        save(s);
      }
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(true); return; }
      if (e.key !== 'Tab') return;
      var f = card.querySelectorAll('button,input,[href]');
      var v = []; for (var i = 0; i < f.length; i++) { if (f[i].offsetParent !== null) v.push(f[i]); }
      if (!v.length) return;
      var first = v[0], last = v[v.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
    back.addEventListener('click', function () { close(true); });
    document.getElementById('CPP-x').addEventListener('click', function () { close(true); });
    document.getElementById('CPP-no').addEventListener('click', function () { close(true); });
    document.getElementById('CPP-s-btn').addEventListener('click', function () { close(false); });

    /* copy code: clipboard API + select-on-tap fallback */
    var copyBtn = document.getElementById('CPP-copy');
    copyBtn.addEventListener('click', function () {
      var code = document.getElementById('CPP-code').textContent.trim();
      function ok() {
        var t = document.getElementById('CPP-copy-t');
        t.textContent = T.copied;
        setTimeout(function () { t.textContent = T.copy; }, 2000);
      }
      function fallback() {
        var el = document.getElementById('CPP-code');
        try {
          var rng = document.createRange(); rng.selectNodeContents(el);
          var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(rng);
          if (document.execCommand && document.execCommand('copy')) ok();
        } catch (e) {}
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(ok, fallback);
      } else { fallback(); }
    });

    /* submit via legacy kmail endpoint (form-encoded = simple request, no CORS preflight; proven in POPUP_REPORT.md) */
    var form = document.getElementById('CPP-form');
    var err = document.getElementById('CPP-err');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var em = document.getElementById('CPP-em').value.trim();
      var fn = document.getElementById('CPP-fn').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) {
        err.textContent = T.err; err.classList.add('cpp-show'); return;
      }
      err.classList.remove('cpp-show');
      var btn = document.getElementById('CPP-go');
      btn.disabled = true;
      var body = 'g=UMBYyf&company_id=SWzQQT' +
        '&email=' + encodeURIComponent(em) +
        '&first_name=' + encodeURIComponent(fn) +
        '&%24source=' + encodeURIComponent('Concept Palermo Popup ' + srcLoc) +
        '&ml_taal=' + encodeURIComponent(lang || '') + '&%24fields=%24source%2Cfirst_name%2Cml_taal';
      function succeed() {
        form.classList.add('cpp-hide');
        document.getElementById('CPP-success').classList.add('cpp-show');
        if (tick) clearInterval(tick);
        var s = st(); s.done = Date.now(); save(s);
        try { document.getElementById('CPP-s-btn').focus({ preventScroll: true }); } catch (e2) {}
      }
      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
        body: body
      }).then(function (r) { return r.json().catch(function () { return { success: r.ok }; }); })
        .then(function (j) {
          btn.disabled = false;
          if (j && j.success !== false) { succeed(); }
          else { err.textContent = T.err; err.classList.add('cpp-show'); }
        })
        .catch(function () { btn.disabled = false; err.textContent = T.err; err.classList.add('cpp-show'); });
    });

    function maybeOpen() {
      try {
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          if (c && c.item_count > 0) return;
          open();
        }).catch(function () { open(); });
      } catch (e) { open(); }
    }
    /* trigger: 25s met cart-check; desktop exit intent */
    if (FORCE) { open(); return; }
    setTimeout(maybeOpen, 35000);
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && window.matchMedia('(min-width:768px)').matches) maybeOpen();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* CPP-POPUP-END */
